export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";